import React from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames';
import './Bubble.scss';

export default function Bubble({ className, active }) {
    const rootClassnames = classnames(
        'bubble',
        {
            'bubble--active': active,
        },
        className,
    );

    return <div className={rootClassnames} />;
}

Bubble.propTypes = {
    className: string,
    active: bool,
};

Bubble.defaultProps = {
    className: null,
    active: false,
};
